var ezdia;
(function (ezdia) {
    var NAME = 'entityLabeling';
    var TYPE = 'entityLabeling';
    var DATA_TYPE = "ez." + TYPE;
    var JQUERY_NO_CONFLICT = $.fn[NAME];
    var COLOR_PALETTE = [
        '#FF5E5E',
        '#FF9F40',
        '#FFCD56',
        '#8CC24A',
        '#4BC0C0',
        '#03A9F4',
        '#9966FF',
        '#FF9D9D',
        '#FFC58B',
        '#FFE29A',
        '#BADA92',
        '#93D9DA',
        '#86C7F3',
        '#C1A3FF'
    ];
    var DEFAULT = {
        column: null,
        value: ''
    };
    var TEMPLATE = ezdia.templates.entityLabeling;
    var $document = $(document);
    // =========================
    var EntityLabeling = /** @class */ (function () {
        function EntityLabeling(elem, options) {
            this.elem = elem;
            this.dom = null;
            this.selectionRangeObj = {
                startOffset: 0,
                endOffset: 0,
                stringValue: ''
            };
            this.colorMap = {};
            this.annotations = [];
            this.shortcutKeys = [];
            this.selectedIndexArray = [];
            this.init(options);
        }
        Object.defineProperty(EntityLabeling.prototype, "Defaults", {
            // eslint-disable-next-line class-methods-use-this
            get: function () {
                return DEFAULT;
            },
            enumerable: false,
            configurable: true
        });
        EntityLabeling.prototype.reviewLabels = function () {
            var e_1, _a;
            var validate = true;
            try {
                for (var _b = __values(this.annotations), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var review = _c.value.review;
                    if (review) {
                        validate = false;
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return validate;
        };
        EntityLabeling.prototype.refresh = function (value) {
            var context = ezdia.util.jsonParse(value);
            var annotations = context.annotations;
            this.annotations = annotations;
            this.setSelectedIndexs(annotations);
            this.setLabelOnContent();
            this.updateFiedValue();
        };
        EntityLabeling.prototype.getLabeledContent = function (value) {
            var labelContent = this.setLabelOnContent(false, value.annotations, true);
            var htmlContent = TEMPLATE.viewLabelingMarkup(labelContent);
            return htmlContent;
        };
        EntityLabeling.prototype.getOptions = function (options) {
            this.convertOptionValueToObject(options);
            return __assign(__assign(__assign({}, DEFAULT), this.$elem.data()), options);
        };
        EntityLabeling.prototype.convertOptionValueToObject = function (options) {
            // eslint-disable-next-line no-param-reassign
            options.value = ezdia.util.jsonParse(options.value) || {};
        };
        EntityLabeling.prototype.init = function (options) {
            this.id = this.elem.id;
            this.name = this.elem.name;
            this.$elem = $(this.elem);
            this.options = this.getOptions(options);
            this.contanerID = ezdia.util.makeId();
            this.labelsContanerID = ezdia.util.makeId();
            this.contentContanerID = ezdia.util.makeId();
            this.setAnnotations();
            this.setSelectedIndexs();
            this.render();
        };
        EntityLabeling.prototype.render = function () {
            var editable = this.options.column.editable;
            this.createView();
            if (this.options.value.content) {
                this.setCache();
                this.setLabelOnContent(true);
                if (editable) {
                    this.events();
                    this.updateFiedValue(true);
                }
            }
            else {
                this.noContentView();
            }
        };
        EntityLabeling.prototype.createView = function () {
            var _a = this.options, column = _a.column, value = _a.value;
            this.formatLabels(column);
            var htmlContent = TEMPLATE.markup({
                column: column,
                value: value,
                labels: this.labels,
                contanerID: this.contanerID,
                labelsContanerID: this.labelsContanerID,
                contentContanerID: this.contentContanerID
            });
            this.$elem.after(htmlContent);
        };
        EntityLabeling.prototype.noContentView = function () {
            var htnlContent = TEMPLATE.noContentMarkup();
            $("#" + this.contanerID)
                .addClass('entity-labeling-nodata')
                .append(htnlContent);
        };
        EntityLabeling.prototype.formatLabels = function (column) {
            var _this = this;
            var _a = column.config, labels = _a.labels, labelsinput = _a.labels_input;
            var entLabels = labels;
            if (labelsinput) {
                entLabels = this.getLabelsFromInput(labelsinput) || entLabels;
            }
            if (entLabels) {
                var labelsArray = Object.entries(entLabels);
                this.labels = labelsArray.map(function (_a, index) {
                    var _b = __read(_a, 2), name = _b[0], props = _b[1];
                    var _c = props, text = _c.text, shortcut = _c.shortcut;
                    var bgColor = COLOR_PALETTE[index];
                    var textColor = '#fff';
                    if (!bgColor) {
                        bgColor = ezdia.util.getColorCode();
                        textColor = ezdia.util.invertColor(bgColor, true);
                    }
                    _this.shortcutKeys.push(shortcut);
                    _this.colorMap[name] = {
                        bgColor: bgColor,
                        textColor: textColor
                    };
                    return {
                        text: text,
                        shortcut: shortcut,
                        type: name,
                        bgColor: bgColor,
                        textColor: textColor
                    };
                });
            }
        };
        EntityLabeling.prototype.getLabelsFromInput = function (fieldName) {
            var _this = this;
            var _a;
            var selectedIds = ezdia.util.getSelectedGridItemsIds();
            if (selectedIds.length !== 1) {
                return '';
            }
            var _b = __read(selectedIds, 1), selectedId = _b[0];
            var gridData = ((_a = ezdia.config.GRID_DATA) === null || _a === void 0 ? void 0 : _a.grid[selectedId]) || {};
            var fieldValue = gridData[fieldName];
            var labelObj = {};
            if (fieldValue) {
                var arr = fieldValue.split(',');
                var shortcutskeys_1 = [];
                arr.forEach(function (label) {
                    var lbl = label.trim();
                    labelObj[lbl] = {
                        text: lbl,
                        shortcut: _this.getshortcut(lbl, shortcutskeys_1)
                    };
                });
                return labelObj;
            }
            return '';
        };
        EntityLabeling.prototype.getshortcut = function (lbl, shortcutskeys) {
            var e_2, _a;
            var lblarr = lbl.toLocaleLowerCase().split('');
            var chararry = 'abcdefghijklmnopqrstuvwxyz'.split('');
            var arr = Array.from(new Set(__spread(lblarr, chararry)));
            var shortcutkey = '';
            try {
                for (var arr_1 = __values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
                    var char = arr_1_1.value;
                    if (!shortcutskeys.includes(char)) {
                        shortcutskeys.push(char);
                        shortcutkey = char;
                        break;
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            return shortcutkey;
        };
        EntityLabeling.prototype.handelOnSelection = function () {
            this.setSelectedRange();
            this.bindOnDocClick();
            this.bindOnKeypress();
        };
        EntityLabeling.prototype.bindOnDocClick = function () {
            $document
                .off("click." + DATA_TYPE)
                .on("click." + DATA_TYPE, this.resetAndoffevents.bind(this));
        };
        EntityLabeling.prototype.bindOnKeypress = function () {
            $document
                .off("keyup." + DATA_TYPE)
                .on("keyup." + DATA_TYPE, this.handelOnkeypress.bind(this));
        };
        EntityLabeling.prototype.handelOnkeypress = function (event) {
            var key = event.key;
            var isShortcutKey = this.shortcutKeys.includes(key);
            if (isShortcutKey) {
                this.dom.$labelContaner
                    .find("[data-shortcut=\"" + key + "\"]")
                    .trigger('click');
            }
        };
        EntityLabeling.prototype.setSelectedRange = function () {
            var contentContaner = this.dom.contentContaner;
            var startOffset = 0;
            var endOffset = 0;
            var stringValue = '';
            if (window.getSelection) {
                var selection = window.getSelection();
                var range = selection.getRangeAt(0);
                var selectionRange = range.cloneRange();
                selectionRange.selectNodeContents(contentContaner);
                selectionRange.setEnd(range.startContainer, range.startOffset);
                stringValue = selection.toString();
                startOffset = selectionRange.toString().length;
                endOffset = startOffset + range.toString().length;
            }
            else if (document.selection &&
                document.selection.type !== 'Control') {
                var selectedTextRange = document.selection.createRange();
                var slectionTextRange = document.body.createTextRange();
                slectionTextRange.moveToElementText(contentContaner);
                slectionTextRange.setEndPoint('EndToStart', selectedTextRange);
                startOffset = slectionTextRange.text.length;
                endOffset = startOffset + selectedTextRange.text.length;
            }
            this.selectionRangeObj = {
                startOffset: startOffset,
                endOffset: endOffset,
                stringValue: stringValue
            };
        };
        EntityLabeling.prototype.validRange = function () {
            var content = this.options.value.content;
            var _a = this.selectionRangeObj, start = _a.startOffset, end = _a.endOffset, stringValue = _a.stringValue;
            var returnVal = true;
            if (!stringValue.trim()) {
                returnVal = false;
            }
            else if (start === end) {
                returnVal = false;
            }
            else if (start > content.length || end > content.length) {
                returnVal = false;
            }
            else if (start < 0 || end < 0) {
                returnVal = false;
            }
            else {
                var isSelected = this.selectedIndexArray.find(function (index) { return index > start && index < end - 1; });
                returnVal = !isSelected;
            }
            return returnVal;
        };
        EntityLabeling.prototype.resetRange = function () {
            this.selectionRangeObj = {
                startOffset: 0,
                endOffset: 0,
                stringValue: ''
            };
        };
        EntityLabeling.prototype.handelLabeling = function (event) {
            if (this.validRange()) {
                var currentTarget = event.currentTarget;
                var index = currentTarget.dataset.index;
                var labelInfo = this.labels[index];
                var _a = this.selectionRangeObj, startOffset = _a.startOffset, endOffset = _a.endOffset;
                this.annotations.push(__assign(__assign({}, this.selectionRangeObj), { label: labelInfo.text, userRole: $.ezdia.config.pageParams.role }));
                this.addSelectedIndexs(startOffset, endOffset);
                this.sortAnnotations();
                this.setLabelOnContent();
                this.updateFiedValue();
            }
        };
        EntityLabeling.prototype.handelDelete = function (event) {
            var target = event.target;
            var index = target.dataset.index;
            var deleteObj = this.annotations[+index];
            this.annotations.splice(+index, 1);
            this.deleteSelectedIndexs(deleteObj);
            this.setLabelOnContent();
            this.updateFiedValue();
        };
        EntityLabeling.prototype.handelVerifier = function (event) {
            var target = event.target;
            var index = target.dataset.index;
            delete this.annotations[+index].review;
            $(target).remove();
            this.updateFiedValue();
        };
        // eslint-disable-next-line consistent-return
        EntityLabeling.prototype.setLabelOnContent = function (render, annotations, disableAction) {
            var e_3, _a;
            var editable = this.options.column.editable;
            var content = this.options.value.content;
            var length = content.length;
            var role = $.ezdia.config.pageParams.role;
            var isChecked = this.getverifierCheck(disableAction);
            var annotationsArray = annotations || this.annotations;
            var lastEndIndex = 0;
            var contentString = '';
            var leftoverString = content;
            var index = 0;
            var remove = editable;
            if (disableAction) {
                remove = false;
            }
            try {
                for (var annotationsArray_1 = __values(annotationsArray), annotationsArray_1_1 = annotationsArray_1.next(); !annotationsArray_1_1.done; annotationsArray_1_1 = annotationsArray_1.next()) {
                    var annotation = annotationsArray_1_1.value;
                    var startOffset = annotation.startOffset, endOffset = annotation.endOffset, label = annotation.label, review = annotation.review, userRole = annotation.userRole;
                    var _b = this.colorMap[label] || {}, bgColor = _b.bgColor, textColor = _b.textColor;
                    var verifierCheck = isChecked;
                    if (verifierCheck) {
                        if (render && userRole !== role) {
                            annotation.review = true;
                        }
                        else if (!review) {
                            verifierCheck = false;
                        }
                    }
                    var labelingString = content.substring(startOffset, endOffset);
                    var labeledString = TEMPLATE.labelMarkup({
                        label: labelingString,
                        index: index,
                        bgColor: bgColor,
                        textColor: textColor,
                        verifierCheck: verifierCheck,
                        remove: remove
                    });
                    contentString += leftoverString.substring(0, startOffset - lastEndIndex);
                    contentString += labeledString;
                    lastEndIndex = endOffset;
                    leftoverString = content.substring(endOffset, length);
                    index += 1;
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (annotationsArray_1_1 && !annotationsArray_1_1.done && (_a = annotationsArray_1.return)) _a.call(annotationsArray_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
            contentString += leftoverString;
            if (!annotations) {
                $("#" + this.contentContanerID).html(contentString);
            }
            else {
                return contentString;
            }
        };
        EntityLabeling.prototype.events = function () {
            var $contentContaner = this.dom.$contentContaner;
            $("#" + this.labelsContanerID).on('click', 'a', this.handelLabeling.bind(this));
            $contentContaner.on('click', this.handelOnSelection.bind(this));
            $contentContaner.on('click', '[data-delete="entity label"]', this.handelDelete.bind(this));
            $contentContaner.on('click', '[data-verifier="entity label"]', this.handelVerifier.bind(this));
        };
        EntityLabeling.prototype.setSelectedIndexs = function (annotationsArray) {
            var e_4, _a;
            var annotations = (annotationsArray || this.options.value).annotations;
            if (annotations && annotations.length) {
                try {
                    for (var annotations_1 = __values(annotations), annotations_1_1 = annotations_1.next(); !annotations_1_1.done; annotations_1_1 = annotations_1.next()) {
                        var _b = annotations_1_1.value, startOffset = _b.startOffset, endOffset = _b.endOffset;
                        this.addSelectedIndexs(startOffset, endOffset);
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (annotations_1_1 && !annotations_1_1.done && (_a = annotations_1.return)) _a.call(annotations_1);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            }
        };
        EntityLabeling.prototype.setAnnotations = function () {
            this.annotations = this.options.value.annotations || [];
        };
        EntityLabeling.prototype.updateFiedValue = function (render) {
            this.options.value.annotations = this.annotations;
            var text = JSON.stringify(this.options.value);
            this.$elem.val(text);
            if (!render) {
                this.$elem.trigger('change');
            }
        };
        EntityLabeling.prototype.setCache = function () {
            this.dom = {
                contentContaner: document.getElementById(this.contentContanerID),
                $contentContaner: $("#" + this.contentContanerID),
                $labelContaner: $("#" + this.labelsContanerID)
            };
        };
        EntityLabeling.prototype.addSelectedIndexs = function (startOffset, endOffset) {
            var index = 0;
            if (endOffset - startOffset === 1) {
                this.selectedIndexArray.push(startOffset);
            }
            else {
                for (index = startOffset; index < endOffset; index++) {
                    this.selectedIndexArray.push(index);
                }
            }
        };
        EntityLabeling.prototype.deleteSelectedIndexs = function (deleteObj) {
            var startOffset = deleteObj.startOffset, endOffset = deleteObj.endOffset;
            var start = this.selectedIndexArray.indexOf(startOffset);
            var end = this.selectedIndexArray.indexOf(endOffset - 1);
            if (endOffset - startOffset === 1) {
                this.selectedIndexArray.splice(start, 1);
            }
            else {
                this.selectedIndexArray.splice(start, end - start + 1);
            }
        };
        EntityLabeling.prototype.sortAnnotations = function () {
            if (this.annotations) {
                this.annotations.sort(function sort(a, b) {
                    return a.startOffset - b.startOffset;
                });
            }
        };
        EntityLabeling.prototype.getverifierCheck = function (disableAction) {
            var editable = this.options.column.editable;
            if (!editable || disableAction) {
                return false;
            }
            var _a = $.ezdia.config.pageParams, roleType = _a.roleType, account = _a.account, submitFields = _a.submitFields;
            var isVerifier = account !== 'expert' && roleType !== 'customer' && roleType !== 'pm';
            var id = ezdia.util.getSelectedGridItemsByGridId();
            var value = $('#grid').jqGrid('getCell', id, submitFields);
            var retVal = false;
            if (value !== 'Submitted' && isVerifier) {
                retVal = true;
            }
            return retVal;
        };
        EntityLabeling.prototype.resetAndoffevents = function (even) {
            var target = even.target;
            if (target.id !== this.contentContanerID) {
                this.resetRange();
                $document.off("keyup." + DATA_TYPE);
                $document.off("click." + DATA_TYPE);
            }
        };
        return EntityLabeling;
    }());
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */
    var publicMethods = {
        reviewLabels: EntityLabeling.prototype.reviewLabels,
        refresh: EntityLabeling.prototype.refresh,
        getLabeledContent: EntityLabeling.prototype.getLabeledContent
        // getValue: EntityLabeling.prototype.getValue,
        // setMode: EntityLabeling.prototype.setMode
    };
    function jQueryInterface(option) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (typeof option === 'string' && option !== 'destroy') {
            return invokePublicMethod.call(this, option, args);
        }
        return createNewInstance.call(this, option);
    }
    function invokePublicMethod(methodName, args) {
        if (publicMethods[methodName]) {
            var inputObject = retrieveObjectFromElement(this);
            var result = publicMethods[methodName].apply(inputObject, args);
            if (typeof result === 'undefined') {
                return $(this);
            }
            return result;
        }
        throw new Error("method '" + methodName + "()' does not exist for input list.");
    }
    // eslint-disable-next-line consistent-return
    function retrieveObjectFromElement(element) {
        var inputObject = $(element).data(DATA_TYPE);
        if (inputObject && inputObject instanceof EntityLabeling) {
            return inputObject;
        }
    }
    function createNewInstance(option) {
        var $this = $(this);
        $this.each(function each() {
            var self = $(this);
            var data = self.data(DATA_TYPE);
            var options = typeof option === 'object' && option;
            if (!data) {
                self.data(DATA_TYPE, (data = new EntityLabeling(this, options)));
            }
            if (typeof option === 'string') {
                data[option]();
            }
        });
        return $this;
    }
    $.fn[NAME] = jQueryInterface;
    $.fn[NAME].Constructor = EntityLabeling;
    $.fn[NAME].noConflict = function noConflict() {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return jQueryInterface;
    };
})(ezdia || (ezdia = {}));
